module.exports = __webpack_public_path__ + "img/Logo_Interreg_Danube.14a360db.png";